const transformAnswers = (answers, questions) => {
  return questions.reduce((acc, question) => {
    const { id, questionOptions, type } = question || {};
    const answer = answers?.[id]?.answer;
    if (type === "FileQuestion" || !answer) return acc;

    switch (true) {
      case Array.isArray(answer):
        // eslint-disable-next-line no-case-declarations
        let selectedOptionIds = [];
        for (let ans of answer) {
          const selectedOption = questionOptions?.find(
            ({ id }) => id === ans?.id
          );

          if (selectedOption) {
            selectedOptionIds.push(selectedOption?.id);
          }
        }
        acc[id] = selectedOptionIds;
        break;
      case ["RadioButtonQuestion", "DropDownQuestion"].includes(type):
        acc[id] = questionOptions?.find(({ id }) => id === answer?.id)?.id;
        break;
      default:
        acc[id] = answer?.value;
        break;
    }

    return acc;
  }, {});
};

export default transformAnswers;
